/**
 * custom-filters.js
 * Кастомні правки фільтрів — ТІЛЬКИ на /collections/all.
 * Інші колекції цей скрипт не зачіпає.
 *
 * 1. REDIRECTS  — статичні фільтри: вибір значення веде на окрему колекцію.
 * 2. RENAME     — інший підпис значення (саме значення фільтра не змінюється).
 * 3. HIDE       — значення, яке ховається зі списку.
 * 4. HIDE_COUNT — значення без лічильника (злиті пункти, сума була б неточною).
 *
 * Злиття дублікатів (Epoxy River Tables, Live edge) зроблено групами
 * в Search & Discovery — воно глобальне, тут його немає.
 *
 * Тема перемальовує фільтри через AJAX після кожного вибору, тому:
 * - редіректи працюють через делегування подій на document (не губляться);
 * - підписи/приховування застосовуються повторно через MutationObserver.
 */
(function () {
  'use strict';

  var PATH = '/collections/all';
  var PREFIX = 'filter.p.m.custom.';

  var REDIRECTS = {
    material: {
      'Walnut': '/collections/walnut-epoxy-tables',
      'Maple': '/collections/maple-epoxy-tables',
      'Oak': '/collections/oak-epoxy-tables',
      'Olive': '/collections/olive-wood-epoxy-tables',
      'Poplar': '/collections/poplar-epoxy-tables'
    },
    shape: {
      'Round': '/collections/round-epoxy-tables',
      'Square': '/collections/custom-epoxy-square-table',
      'Oval': '/collections/oval-epoxy-resin-tables',
      'Rectangular': '/collections/rectangular-epoxy-resin-tables'
    },
    design: {
      'Floral': '/collections/epoxy-flower-tables',
      'Pressed flowers': '/collections/epoxy-flower-tables',
      'Side tables': '/collections/c-tables',
      'Waterfall tables': '/collections/waterfall-epoxy-tables'
    }
  };

  var RENAME = {
    design: {
      'Epoxy river': 'Epoxy River Furniture',
      'Floral': 'Epoxy Flower Tables'
    }
  };

  var HIDE = {
    design: ['Solid wood', 'Pressed flowers']
  };

  var HIDE_COUNT = {
    design: ['Floral']
  };

  if (window.location.pathname !== PATH) return;

  function groupOf(name) {
    return name && name.indexOf(PREFIX) === 0 ? name.slice(PREFIX.length) : null;
  }

  function lookup(map, group, value) {
    return map[group] ? map[group][value] : undefined;
  }

  function inList(map, group, value) {
    return !!(map[group] && map[group].indexOf(value) !== -1);
  }

  /* ---------- 1. Статичні фільтри (делегування, capture) ---------- */

  function redirect(e, target) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = target;
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.tagName !== 'INPUT' || !el.checked) return;
    var target = lookup(REDIRECTS, groupOf(el.name), el.value);
    if (!target) return;
    el.checked = false;
    redirect(e, target);
  }, true);

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="' + PREFIX + '"]');
    if (!a || a.hasAttribute('data-remove-filter')) return;
    var params = new URL(a.href, window.location.origin).searchParams;
    var target = null;
    params.forEach(function (value, key) {
      target = target || lookup(REDIRECTS, groupOf(key), value) || null;
    });
    if (target) redirect(e, target);
  }, true);

  /* ---------- 2–4. Підписи, приховування, лічильники ---------- */

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  function hide(el) {
    if (el && el.style.display !== 'none') el.style.display = 'none';
  }

  function tweakItems() {
    var inputs = document.querySelectorAll('input[name^="' + PREFIX + '"]');
    Array.prototype.forEach.call(inputs, function (input) {
      var group = groupOf(input.name);
      var value = input.value;
      var item = input.closest('li') || input.closest('.filter-item');
      if (!item) return;

      if (inList(HIDE, group, value)) {
        hide(item);
        return;
      }

      var label = lookup(RENAME, group, value);
      if (label) setText(item.querySelector('.filter-item__label'), label);

      if (inList(HIDE_COUNT, group, value)) {
        hide(item.querySelector('.filter-item__count'));
      }
    });
  }

  function tweakActiveChips() {
    var chips = document.querySelectorAll('[data-remove-filter][data-name^="' + PREFIX + '"]');
    Array.prototype.forEach.call(chips, function (chip) {
      var label = lookup(RENAME, groupOf(chip.getAttribute('data-name')), chip.getAttribute('data-value'));
      if (!label) return;
      var node = chip.firstChild;
      if (node && node.nodeType === 3 && node.textContent.trim() !== label) {
        node.textContent = label + '\n';
      }
    });

    var summaries = document.querySelectorAll('.filter-group__values-active-values');
    Array.prototype.forEach.call(summaries, function (el) {
      var text = el.textContent;
      var next = text;
      Object.keys(RENAME).forEach(function (group) {
        Object.keys(RENAME[group]).forEach(function (from) {
          var re = new RegExp('(^|,\\s*)' + from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?=\\s*(,|$))', 'g');
          next = next.replace(re, '$1' + RENAME[group][from]);
        });
      });
      if (next !== text) el.textContent = next;
    });
  }

  function apply() {
    tweakItems();
    tweakActiveChips();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function init() {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  document.addEventListener('shopify:section:load', schedule);
})();